import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import './modal.css';
import { rejeitar } from '@app/api/RegraSubstituto';
import * as Yup from 'yup';

export interface propsModalRejeitar {
  regraId: string;
  updatePage: any;
}

const ModalRejeitar = (props: propsModalRejeitar) => {
  const { regraId, updatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = (values: any) => {
    rejeitar(regraId, values.motivo).then(data => {
      if (data) {
        setExibirModal(false);
        updatePage();
      }
    });
  };

  return (
    <>
      <Tooltip title="Rejeitar">
        <Button
          onClick={() => {
            setExibirModal(true);
          }}
          icon="commons-cancel_2"
          name="btnRejeitar"
        />
      </Tooltip>
      <Modal
        title="Rejeitar"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            motivo: Yup.string().required('O Motivo é obrigatório'),
          })}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton noIcon={true} type="primary">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormTextArea name="motivo" label="Motivo" span={12} rows={4} maxLength={2000} />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalRejeitar;
